import styled from 'styled-components';

import { ReactComponent as ClockIcon } from '../../../../assets/images/blueTheme/clock.svg';
import { StyledTable } from '../../../../components/BlueTheme/Table/styled';

export const StyledStandardDeliveryTable = styled(StyledTable)`
  tr td.sticky:nth-child(2),
  tr th.sticky:nth-child(2) {
    left: 32px;
  }

  th,
  td {
    letter-spacing: 0;
  }

  .sticky {
    border-right: 1px solid ${({ theme }): string => theme.admanColors!.gray.light.bg3[2]};
  }
`;

export const ClockIconWrapper = styled(ClockIcon)`
  width: 16px;
  height: 16px;
  margin-right: ${({ theme: { spacers } }): string => `${spacers!.spacer02}`};

  path {
    fill: ${({ theme }): string => theme.admanColors!.gray.light.bg3[1]};
  }
`;

export const StyledTitleWrapper = styled.div`
  line-height: 18px;
`;

export const StyledSubHeader = styled.div`
  max-width: 120px;
`;

export const StyledNumberWrapper = styled.div`
  text-align: right;
`;
